// frontend/shared-ui/src/auth/Can.jsx
import React from "react";
import { usePermissions, checkPermission } from "./PermissionsContext";

export default function Can({
  permission,
  anyOf,
  allOf,
  children,
  fallback = null,
}) {
  const { permissions } = usePermissions();

  let allowed = false;
  if (permission) allowed = checkPermission(permissions, permission);
  else if (anyOf?.length)
    allowed = anyOf.some((p) => checkPermission(permissions, p));
  else if (allOf?.length)
    allowed = allOf.every((p) => checkPermission(permissions, p));
  else allowed = true;

  if (!allowed) return fallback;
  return children;
}
